import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  copy(event) {
    const text = event.params.text
    const message = event.params.message || "Copied!"
    const trigger = event.currentTarget || this.element
    const originalHtml = trigger.innerHTML

    if (!text) {
      return
    }

    const showCopied = () => {
      trigger.innerHTML = message
      window.setTimeout(() => {
        trigger.innerHTML = originalHtml
      }, 2000)
    }

    const fallbackCopy = () => {
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.setAttribute("readonly", "")
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      const copied = document.execCommand("copy")
      document.body.removeChild(textarea)
      if (copied) {
        showCopied()
      }
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(showCopied, fallbackCopy)
    } else {
      fallbackCopy()
    }
  }
}
